import { Icon } from "../components/Icon";
import { Tooltip } from "../components/Tooltip";
import { cn } from "../lib/utils";
import * as React from "react";
const PillButton = React.forwardRef(({
  className,
  icon,
  label,
  tooltipShortcut,
  tooltipSide,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Tooltip, {
  label: label,
  shortcut: tooltipShortcut,
  side: tooltipSide,
  tooltipTriggerAsChild: true,
  trigger: /*#__PURE__*/React.createElement("button", {
    ref: ref,
    type: "button",
    "aria-label": label,
    className: cn("pill-button touch-hitbox", className),
    ...props
  }, /*#__PURE__*/React.createElement(Icon, {
    visual: icon,
    size: "sm"
  }))
}));
PillButton.displayName = "PillButton";
export { PillButton };
//# sourceMappingURL=PillButton.js.map